// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const ro: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Cum se joacă',
  'howto.pieces.heading': 'Piesele',
  'howto.pieces.source': 'Sursă',
  'howto.pieces.mirror': 'Oglindă',
  'howto.pieces.switch': 'Comutator',
  'howto.pieces.exit': 'Ieșire',
  'howto.pieces.wall': 'Zid',
  'howto.controls.heading': 'Comenzile',
  'howto.controls.clickSlot.line1': 'Clic pe slot',
  'howto.controls.clickSlot.line2': 'plasează oglinda',
  'howto.controls.dragMirror.line1': 'Trage oglinda',
  'howto.controls.dragMirror.line2': 'rotește',
  'howto.controls.rightClick.line1': 'Clic dreapta',
  'howto.controls.rightClick.line2': 'scoate oglinda',
  'howto.controls.hint': 'Rotița mouse-ului: rotire fină cu 1°.   Atingere oglindă: rotire cu 15°.',
  'howto.objective.line1': 'Aprinde fiecare comutator — încuietoarea ieșirii se deschide.',
  'howto.objective.line2': 'Apoi clic pe ieșire. Rezolvă cu cât mai puține oglinzi.',

  'howtoColor.title': 'Culoare și prisme',
  'howtoColor.pieces.heading': 'Piese noi',
  'howtoColor.pieces.prism': 'Prismă',
  'howtoColor.pieces.redSwitch': 'Comutator roșu',
  'howtoColor.pieces.yellowSwitch': 'Comutator galben',
  'howtoColor.pieces.whiteSwitch': 'Comutator alb',
  'howtoColor.how.heading': 'Cum funcționează',
  'howtoColor.how.line1': 'O rază albă transportă lumină roșie, verde și albastră în același timp.',
  'howtoColor.how.line2':
    'O prismă desparte lumina albă în trei raze colorate, pe cele trei laturi ale ei.',
  'howtoColor.how.line3': 'Clic pe o prismă plasată pentru a roti latura de intrare.',
  'howtoColor.switches.line1': 'Comutatoarele au puncte colorate — aceea e culoarea pe care o cer.',
  'howtoColor.switches.line2':
    'Un comutator galben (puncte roșu + verde) are nevoie de ambele culori.',
  'howtoColor.switches.line3':
    'Un comutator alb (toate trei) are nevoie de roșu, verde ȘI albastru în același timp.',

  'options.hints.label': 'Afișează unghiurile sugestiilor în puzzle-uri',
  'options.hints.help':
    'Afișează unghiul dintre raza incidentă și cea reflectată la fiecare reflexie.',

  'level.01-intro.title': 'Salut, lumină',
  'level.02-two-mirrors.title': 'Două viraje',
  'level.03-corner.title': 'Zid în cale',
  'level.04-two-targets.title': 'Două ținte',
  'level.05-tight.title': 'Strâmt',
  'level.06-hello-color.title': 'Salut, culoare',
  'level.07-pick-a-side.title': 'Alege o latură',
  'level.08-yellow.title': 'Galben',
  'level.09-magenta.title': 'Magenta',
  'level.10-spectrum.title': 'Spectru',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'drept',
  'puzzle.hint.angleType.acute': 'ascuțit',
  'puzzle.hint.angleType.obtuse': 'obtuz',
  'puzzle.hint.label': '{angle}°\n{type}',
};
